export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-baseline leading-none ${className}`} aria-label="SÛRSWA AI">
    <span className="logo-metal font-display font-light tracking-[0.28em]">SÛRSWA</span>
    <span className="logo-metal font-display font-normal tracking-[0.3em] text-[0.5em] ml-[0.55em]">AI</span>
  </span>
);
